import { render, staticRenderFns } from "./BpmBizBatchEntrusterDealModal.vue?vue&type=template&id=ad4d1952&scoped=true&"
import script from "./BpmBizBatchEntrusterDealModal.vue?vue&type=script&lang=js&"
export * from "./BpmBizBatchEntrusterDealModal.vue?vue&type=script&lang=js&"
import style0 from "./BpmBizBatchEntrusterDealModal.vue?vue&type=style&index=0&id=ad4d1952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4d1952",
  null
  
)

export default component.exports